export default __webpack_public_path__ + "static/media/red.f05de417.svg";